import { render } from "./CustomReminders.vue?vue&type=template&id=4d0c3061&scoped=true"
import script from "./CustomReminders.vue?vue&type=script&lang=js"
export * from "./CustomReminders.vue?vue&type=script&lang=js"

import "./CustomReminders.vue?vue&type=style&index=0&id=4d0c3061&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d0c3061"]])

export default __exports__